import App from './App'
import FilmBoard from './components/FilmBoard'
import ActorBoard from './components/ActorBoard'

import Dashboard from './components/Dashboard'
import Film from './components/Film'
import LoginPage from './components/LoginPage'

export default [
    {
        path: '/', component: App,
        children: [
            {
                path: '/', component: Dashboard,
            },
            {
                path: 'filmBoard',
                component: FilmBoard
            },
            {
                path: 'actorBoard',
                component: ActorBoard
            },

            {
                name: 'film',
                path: 'film/:code',
                component: Film,
                props: true
            }
        ]
    },
    {
        path: '/login', component: LoginPage,
    }
]